import React from 'react';
import StyledInput, { useStyles } from './styles';

export default function Input(props) {
  const classes = useStyles(props);
  return (
    <StyledInput {...props} variant="standard" className={classes.styles} />
  );
}
